import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import useIsMobile from '../../hooks/useIsMobile'

function LinkButton ({ href, children }) {
  return (
    <Link
      href={href}
      className={'btn btn-outline-primary border-0 btn-sm flex-shrink-0'}
    >
      {children}
    </Link>
  )
}

function Slash () {
  return (
    <div className={'text-dark text-opacity-75'}>
      /
    </div>
  )
}

export default function BreadCrumbs ({ stateData, cityData, storeData }) {
  const isMobile = useIsMobile()

  return (
    <Container
      className={'d-flex gap-1 align-items-baseline mb-3 mt-2'}
      style={{
        overflowX: isMobile ? 'auto' : ''
      }}
    >
      <LinkButton href={'/store/'}>
        Ivy Flip
      </LinkButton>

      <Slash />

      {stateData && (
        <>
          <LinkButton href={`/${stateData.slug}`}>
            {stateData.name}
          </LinkButton>

          <Slash />
        </>
      )}

      {(stateData && cityData) && (
        <>
          <LinkButton href={`/${stateData.slug}/${cityData.slug}`}>
            {cityData.name}
          </LinkButton>

          <Slash />
        </>
      )}

      {storeData && (
        <>
          <LinkButton
            href={`/store/${storeData.slug}`}
            legacyBehavior
          >
            {storeData.name}
          </LinkButton>

          <Slash />
        </>
      )}
    </Container>
  )
}